import { FC } from 'react'
import styled from 'styled-components'

interface Props {
  className?: string
}
export const ArrowDownFixed: FC<Props> = ({ className }) => {
  return (
    <SpanWrapper className={className}>
      <span className="arrow down" />
    </SpanWrapper>
  )
}
export const ArrowBackFixed: FC<Props> = ({ className }) => {
  return (
    <SpanWrapper className={className}>
      <span className="arrow back" />
    </SpanWrapper>
  )
}
const SpanWrapper = styled.div`
  height: 20px;
  display: flex;
  justify-content: center;

  span {
    width: 12px;
    height: 12px;
    background: transparent;

    border-top: 3px solid ${({ theme }) => theme.text};
    border-right: 3px solid ${({ theme }) => theme.text};
    box-shadow: 0 0 0 lightgray;
    transition: all 200ms ease;
  }

  span.down {
    left: 0;
    transform: translate3d(0, -50%, 0) rotate(135deg);
  }
  span.back {
    left: 0;
    transform: translate3d(0, 25%, 0) rotate(225deg);
  }

  span:before {
    // for better hit area
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-40%, -60%) rotate(45deg);
    width: 200%;
    height: 200%;
    color: yellow;
  }
`
